module.exports = __webpack_public_path__ + "static/media/name.13b6de54.svg";